"use client";

import dynamic from "next/dynamic";

/**
 * Client-only wrapper: Three.js Canvas + R3F never run on the server.
 * Use this instead of importing `pixel-effect.tsx` directly.
 */
export const PixelEffect = dynamic(
  () =>
    import("./pixel-effect").then((mod) => ({
      default: mod.PixelEffect,
    })),
  { ssr: false, loading: () => null }
);
